<script>
import Carousel from '@/Carousel'
import Slide from '@/Slide'
export default {
  name: 'VueConciseCarousel',
  functional: true,
  Carousel,
  Slide,
}
</script>
